module.exports = __webpack_public_path__ + "img/salon-hospitality.866bcd5d.svg";